import LocalStorage from './LocalStorage'
import SessionStorage from './SessionStorage'

export default (session = false) => {
  if (!session && process.env.REACT_APP_STORAGE === 'localStorage') {
    return LocalStorage
  } else {
    return SessionStorage
  }
}
